/* UtilBreakpoints util - emit::on:breakpoint:changed{detail:{old:<lastBreakpoint>,new:<activeBreakpoint>}} */
export default class UtilBreakpoints {
    constructor(bodyElement = document.body) {
        if (UtilBreakpoints.instance) {
            return UtilBreakpoints.instance;
        }
        this._body = bodyElement || document.body;
        this._breakpoints = null;
        this.activeBreakpoint = this.getCurrent();
        this.lastBreakpoint = this.activeBreakpoint;
        this.saveAllBreakpoints();
        window.addEventListener('orientationchange', () => this._refreshCurrent());
        window.addEventListener('resize', () => this._refreshCurrent());
        UtilBreakpoints.instance = this;
    }
    /**
     * Getter for breakpoints
     *
     * @return {array}
     */
    get breakpoints() {
        if (this._breakpoints === null) {
            this.saveAllBreakpoints();
        }
        return this._breakpoints || [];
    }
    /**
     * Setter for breakpoints
     *
     * @param {array} breakpointsArray
     */
    set breakpoints(breakpointsArray) {
        this._breakpoints = breakpointsArray;
    }
    /**
     * Update the activeBreakpoint from css
     */
    _refreshCurrent() {
        const bpActiveString = window
            .getComputedStyle(this._body, '::before')
            .getPropertyValue('content')
            .replace(/("|')/g, '');
        if (bpActiveString !== '' && bpActiveString !== 'none') {
            /* Emit an event if the breakpoint has changed */
            if (bpActiveString !== this.activeBreakpoint) {
                this.lastBreakpoint = this.activeBreakpoint;
                this.activeBreakpoint = bpActiveString;
                const changeEvent = new CustomEvent('on:breakpoint:changed', {
                    detail: {
                        old: this.lastBreakpoint,
                        new: this.activeBreakpoint,
                    },
                });
                window.dispatchEvent(changeEvent);
            }
        }
    }
    /**
     * Update the available breakpoints from css
     */
    saveAllBreakpoints() {
        const bpString = window.getComputedStyle(this._body, '::after').getPropertyValue('content').replace(/("|')/g, '');
        if (bpString !== '' && bpString !== 'none') {
            this.breakpoints = bpString.split(',');
        }
    }
    /**
     * Get the active breakpoint and return it
     *
     * @param {boolean} force
     * @return {string}
     */
    getCurrent(force = false) {
        if (force || !this.activeBreakpoint) {
            this._refreshCurrent();
        }
        return this.activeBreakpoint;
    }
    /**
     * Returns true if bp is this size or larger
     *
     * @param {string} bp
     * @return {boolean}
     */
    breakpointUp(bp) {
        const current = this.getCurrent();
        const use = [];
        let found = false;
        this.checkBreakpoint(bp, current);
        for (let i = 0; i < this.breakpoints.length; i++) {
            const breakpoint = this.breakpoints[i].replace("'", '');
            if (breakpoint === bp) {
                found = true;
            }
            if (found === true) {
                use.push(breakpoint);
            }
        }
        return use.indexOf(current) >= 0;
    }
    /**
     * Returns true if bp is this size or smaller
     *
     * @param {string} bp
     * @return {boolean}
     */
    breakpointDown(bp) {
        const current = this.getCurrent();
        const use = [];
        let found = false;
        this.checkBreakpoint(bp, current);
        for (let i = this.breakpoints.length - 1; i >= 0; i--) {
            const breakpoint = this.breakpoints[i].replace("'", '');
            if (breakpoint === bp) {
                found = true;
            }
            if (found === true) {
                use.push(breakpoint);
            }
        }
        return use.indexOf(current) >= 0;
    }
    /**
     * Returns true if bp is this size
     *
     * @param {string} bp
     * @param {string} current
     * @return {boolean}
     */
    checkBreakpoint(bp, current) {
        if (this.breakpoints.indexOf(current) < 0) {
            new Error(`The breakpoint ${bp} does not exists!`);
        }
    }
    /**
     * Check if the breakpoint has changed
     *
     * @return {boolean}
     */
    hasChanged() {
        return this.getCurrent(true) !== this.lastBreakpoint;
    }
}
